$ = jQuery;

$(document).ready(function(){
	var args = {
		slidesToScroll: 1,
		infinite: false,
		centerMode: false,
		prevArrow: '<button type="button" class="timeline-arrow timeline-arrow-prev slick-prev slick-arrow bg-transparent py-0 px-0 border-0" aria-label="Go to previous slide"><span class="fal fa-arrow-left"></span></button>',
		nextArrow: '<button type="button" class="timeline-arrow timeline-arrow-next slick-next slick-arrow bg-transparent py-0 px-0 border-0" aria-label="Go to next slide"><span class="fal fa-arrow-right"></span></button>',
			
		responsive: [
			{
				breakpoint: 4000
				, settings: {
					slidesToShow: 4
				}
			}
			// , {
			// 	breakpoint: 992
			// 	, settings: {
			// 		slidesToShow: 3
			// 	}
			// }
			// , {
			// 	breakpoint: 768
			// 	, settings: {
			// 		arrows: false
			// 		, slidesToShow: 2
			// 	}
			// }
			// , {
			// 	breakpoint: 576
			// 	, settings: {
			// 		slidesToShow: 4
			// 		// , dots: true
			// 		, arrows: true
			// 	}
			// }
		]
	};

	setTimeout(function(){ 
		$('#timeline .slick-slide').first().find('.position-static').addClass('timeline-current timeline-active');
	}, 
		0);


	$('.timeline-card-deck').slick(args);

	$('.timeline-link').on('click', function(ev){

		$('.timeline-current').removeClass('timeline-current');

		$(this).closest('.slick-slide').find('.position-static').addClass('timeline-current timeline-active');
		$(this).closest('.slick-slide').prevAll().find('.position-static').addClass('timeline-active');
		$(this).closest('.slick-slide').nextAll().find('.position-static').removeClass('timeline-active');


		// Add border to dots for current slides
		// $('.slick-current').find('.round-dot').css({"border-color": "#000000", "border-width":"1px", "border-style":"solid"});
		$('.slick-current').removeClass('slick-current');

		//	Prevent text to hide if it already has class .show (prevent hiding section by double clicking)
		// Source: https://stackoverflow.com/questions/43592859/bootstrap-accordion-dont-collapse-if-clicking-on-open-panel?rq=1
		if ($(ev.currentTarget.attributes['data-target'].nodeValue).hasClass('show')) {
			event.stopPropagation();
		}
		
		var active = ev.target.closest(".slick-active");
		active.classList.add('slick-current');
	});

	$('.timeline-arrow').click(function(){

		var timeline_descriptions = $('.position-relative.fly-in');

		var currently_shown = $('.position-relative.show');
		if ($(this).hasClass('timeline-arrow-next')){

			console.log(currently_shown.data('description-number') + 1, timeline_descriptions.length);

			if ((timeline_descriptions.length - currently_shown.data('description-number') )!== 1){
				currently_shown.removeClass('show');
				currently_shown.next().addClass('show');
				$('.timeline-current').removeClass('timeline-current').closest('.slick-slide').next('.slick-slide').find('.position-static').addClass('timeline-current timeline-active');
			}
		}
		else{

			if (currently_shown.data('description-number') !== 0  ){
				currently_shown.removeClass('show');
				currently_shown.prev().addClass('show');
				$('.timeline-current').removeClass('timeline-current').closest('.slick-slide').prev('.slick-slide').find('.position-static').addClass('timeline-current');
				$('.timeline-current').closest('.slick-slide').nextAll().find('.position-static').removeClass('timeline-active');

			}

		}
	})

	var args = {
		slidesToScroll: 1,
		// centerMode: true,
		prevArrow: '<button type="button" class="team-arrow slick-prev slick-arrow bg-transparent py-0 px-0 border-0" aria-label="Go to previous slide"><span class="fal fa-arrow-left"></span></button>',
		nextArrow: '<button type="button" class="team-arrow slick-next slick-arrow bg-transparent py-0 px-0 border-0" aria-label="Go to next slide"><span class="fal fa-arrow-right"></span></button>',
			
		responsive: [
			{
				breakpoint: 4000
				, settings: {
					slidesToShow: 4
				}
			}
			, {
				breakpoint: 992
				, settings: {
					slidesToShow: 3
				}
			}
			, {
				breakpoint: 768
				, settings: {
					arrows: false
					, slidesToShow: 2
				}
			}
			, {
				breakpoint: 576
				, settings: {
					slidesToShow: 1
					, dots: true
				}
			}
		]
	};
	$('.team-card-deck').slick(args);

	var args = {
		slidesToScroll: 1,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 6000,
		prevArrow: '<button type="button" class="our-team-arrow slick-prev slick-arrow bg-transparent py-0 px-0 border-0" aria-label="Go to previous slide"><span class="fal fa-arrow-left"></span></button>',
		nextArrow: '<button type="button" class="our-team-arrow slick-next slick-arrow bg-transparent py-0 px-0 border-0" aria-label="Go to next slide"><span class="fal fa-arrow-right"></span></button>',
			
		responsive: [
			{
				breakpoint: 4000
				, settings: {
					slidesToShow: 1
				}
			}
			, {
				breakpoint: 992
				, settings: {
					slidesToShow: 1
				}
			}
			, {
				breakpoint: 768
				, settings: {
					// arrows: false
					// , 
					slidesToShow: 1
				}
			}
			, {
				breakpoint: 576
				, settings: {
					slidesToShow: 1
					, dots: true
				}
			}
		]
	};
	$('.our-team-card-deck').slick(args);


	// Calculate width between elements
	function getPositionAtCenter(element) {
   const {top, left, width, height} = element.getBoundingClientRect();
   return {
     x: left + width / 2,
     y: top + height / 2
   };
 }

function getDistanceBetweenElements(a, b) {
  const aPosition = getPositionAtCenter(a);
  const bPosition = getPositionAtCenter(b);

  return Math.hypot(aPosition.x - bPosition.x, aPosition.y - bPosition.y);  
}

const distance = getDistanceBetweenElements(
  document.getElementById("btn-0"),
  document.getElementById("btn-3")
);
console.log(distance);

});
